import { useTranslation } from 'react-i18next';

import { Content, Description, MainInfo, Label, Property, AdditionalInfo, CloseButton, Scroller } from './info-block.styled';

export const InfoBlock = (props) => {
  const { title, info, close, fields } = props;

  const { t } = useTranslation();

  if (!info) {
    return null;
  }

  const getFieldsEl = () => {
    return fields.map((field, idx) => (
      <Property key={idx}>
        <Label>{field.title}</Label>
        <span>{field.value}</span>
      </Property>
    ));
  };

  const fieldsEl = getFieldsEl();

  return (
    <Content>
      <Description>
        {title}
        <CloseButton onClick={close} />
      </Description>

      <Scroller>
        <MainInfo>{fieldsEl}</MainInfo>
        <AdditionalInfo>
          <Label>{t('grid.Дополнительно')}</Label>
          <pre>
            <br />
            {JSON.stringify(info, null, 2)}
          </pre>
        </AdditionalInfo>
      </Scroller>
    </Content>
  );
};
